// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';
import { type Address, type AddressWireFormat, NewAddress } from '../Address/Address';
import { type Division, type DivisionWireFormat, NewDivision } from '../Division/Division';
import { NewUser, type User, type UserWireFormat } from '../User/User';

export class Market {
  readonly id: string;
  readonly name: string;
  readonly address: Address | null;
  readonly phoneNumber: string | null;
  readonly phoneNumber2: string | null;
  readonly divisionId: string | null;
  readonly division: Division | null;
  readonly users: User[];

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.name = data.name === undefined ? '' : data.name;
    this.address =
      // eslint-disable-next-line no-nested-ternary
      (data.address ?? null) === null ? null : NewAddress(data.address);
    this.phoneNumber = data.phoneNumber === undefined ? null : data.phoneNumber;
    this.phoneNumber2 = data.phoneNumber2 === undefined ? null : data.phoneNumber2;
    this.divisionId = data.divisionId === undefined ? null : data.divisionId;
    this.division =
      // eslint-disable-next-line no-nested-ternary
      (data.division ?? null) === null ? null : NewDivision(data.division);
    this.users = (data.users ?? []).map((users: any) => NewUser(users));
  }

  static zero(): Market {
    const zeroValues: ExcludeMethodsDeep<Market> = {
      id: NIL_UUID,
      name: '',
      address: null,
      phoneNumber: null,
      phoneNumber2: null,
      divisionId: null,
      division: null,
      users: [],
    };
    return new Market(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************

  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type MarketWireFormat = {
  id: string;
  name: string;
  address: AddressWireFormat | null;
  phoneNumber: string | null;
  phoneNumber2: string | null;
  divisionId: string | null;
  division: DivisionWireFormat | null;
  users: UserWireFormat[];
};

type NewMarketProps = PartialDeep<Market, { recurseIntoArrays: true }>;
export const NewMarket: (props: NewMarketProps) => Market = (props) => new Market(props);

type NewMarketFromWireFormatProps = PartialDeep<MarketWireFormat, { recurseIntoArrays: true }>;
export const NewMarketFromWireFormat: (props: NewMarketFromWireFormatProps) => Market = (props) =>
  new Market(props);
